import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button, Alert, FormBoxCompat } from "@impero-com/ui";

import { BulkAssignStep } from "../stepsContainer";

import { ControlProgramExporter } from "./controlProgramExporter";
import * as theme from "./theme.css";

interface ExportAssignmentsProps {
    onStepChange: (step: BulkAssignStep) => void;
}

export function ExportAssignmentsStep({
    onStepChange,
}: ExportAssignmentsProps) {
    const { t } = useTranslation();

    const handleNextStep = () => {
        onStepChange("upload");
    };

    return (
        <FormBoxCompat>
            <div className={theme.stepContainer}>
                <h2>{t("ControlsBulkAssign_ExportStep_Title")}</h2>
                <Alert
                    showIcon={true}
                    type="info"
                    message={t("ControlsBulkAssign_ExportStep_Instructions")}
                    className={theme.infoAlertBox}
                />
                <ControlProgramExporter onExport={handleNextStep} />
                <div className={theme.buttonGroup}>
                    <Button variant="primary" onClick={handleNextStep}>
                        {t("ControlsBulkAssign_ExportStep_SkipButton")}
                    </Button>
                </div>
            </div>
        </FormBoxCompat>
    );
}
